export default __webpack_public_path__ + "static/media/019-history.72bfbdf7.png";